var map = {
	"./animareal.png": 69,
	"./daikanyama.png": 70,
	"./eiyahon.png": 71,
	"./gifbit.png": 72,
	"./hirakata.png": 73,
	"./iosys.png": 74,
	"./rainbird.png": 75,
	"./rakunew.png": 76,
	"./repanda.png": 77,
	"./routeone.png": 78,
	"./softbank.png": 79,
	"./tone.png": 80,
	"./tsutaya.png": 81,
	"./tsutayabooks.png": 82,
	"./tsutayaelectrics.png": 83,
	"./unicase.png": 84,
	"./uuum.png": 85
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;


//////////////////
// WEBPACK FOOTER
// ./src/logos nonrecursive \.png$
// module id = 68
// module chunks = 0